/**
 * 统一获取环境信息
 * @author tylerzzheng
 */

// export const isProd: boolean = true
export const isProd: boolean = window.location.hostname === 'tcc.tencent.com'
